import React, { useRef, useState } from 'react';
import { uploadAnswerBlob } from '../../utils/uploadAnswer';

export default function MathAnswer({ attemptId, questionId, onSaved, disabled = false }) {
    const [val, setVal] = useState('');
    const [err, setErr] = useState('');
    const previewRef = useRef(null);

    async function saveAsPng() {
        setErr('');
        try {
            const pngBlob = renderTextToPng(val);
            const filename = `math-${questionId}-${Date.now()}.png`;
            const { file_key, meta } = await uploadAnswerBlob({
                attemptId, questionId, blob: pngBlob, filename, contentType: 'image/png',
                extraMeta: { kind: 'math', raw: val }
            });
            onSaved?.({ file_key, meta });
        } catch (e) {
            setErr(e.message || 'Błąd zapisu');
        }
    }

    return (
        <div style={{ display:'grid', gap:8 }}>
            <div style={{ fontSize:14, opacity:0.8 }}>Wpisz wzory (np. LaTeX) – zapis zostanie zrenderowany do PNG, a surowy tekst trafi do metadanych.</div>
            <textarea
                value={val}
                onChange={e=>setVal(e.target.value)}
                rows={8}
                placeholder="Np. \int_0^1 x^2 dx = 1/3"
                disabled={disabled}
                style={{ width:'100%' }}
            />
            <div style={{ display:'flex', gap:8 }}>
                <button onClick={saveAsPng} disabled={disabled || !val.trim()}>Zapisz jako PNG</button>
            </div>
            {err && <div style={{ color:'#a00' }}>{err}</div>}
            <div ref={previewRef} />
        </div>
    );
}

// Proste renderowanie tekstu do PNG (monospace, zawijanie linii)
function renderTextToPng(text){
    const pad = 24;
    const lines = (text || '').replace(/\r/g,'').split('\n');
    const metrics = { lineH: 24, font: '16px ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace' };
    const maxChars = Math.max(40, Math.min(120, Math.max(...lines.map(l => l.length), 0)));
    const w = Math.min(1600, Math.max(600, Math.round(maxChars * 9.5) + pad*2));
    const h = Math.max(200, lines.length * metrics.lineH + pad*2);

    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff'; ctx.fillRect(0,0,w,h);
    ctx.fillStyle = '#000'; ctx.font = metrics.font;
    ctx.textBaseline = 'top';

    let y = pad;
    for (const ln of lines) {
        const wrapped = wrapText(ctx, ln, w - pad*2);
        for (const seg of wrapped) {
            ctx.fillText(seg, pad, y);
            y += metrics.lineH;
        }
    }
    return dataUrlToBlob(c.toDataURL('image/png', 0.95));
}

function wrapText(ctx, text, maxWidth){
    const words = (text || '').split(/(\s+)/);
    const lines = [];
    let cur = '';
    for (const w of words) {
        const test = cur + w;
        if (ctx.measureText(test).width > maxWidth && cur) {
            lines.push(cur);
            cur = w.trimStart();
        } else cur = test;
    }
    if (cur) lines.push(cur);
    return lines;
}
function dataUrlToBlob(dataUrl){
    const [head, data] = dataUrl.split(',');
    const mime = (head.match(/data:(.*?);base64/) || [])[1] || 'image/png';
    const bin = atob(data); const len = bin.length;
    const u8 = new Uint8Array(len);
    for (let i=0;i<len;i++) u8[i] = bin.charCodeAt(i);
    return new Blob([u8], { type: mime });
}
